/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Reviews_SubtitleInputs */

const es_marketplace_seo_galicia_reviews_subtitle = /** @type {(inputs: Marketplace_Seo_Galicia_Reviews_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseñas reales de navegantes que reservaron en las Rías Baixas y la costa gallega.`)
};

const gl_marketplace_seo_galicia_reviews_subtitle = /** @type {(inputs: Marketplace_Seo_Galicia_Reviews_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseñas reais de navegantes que reservaron nas Rías Baixas e a costa galega.`)
};

const en_marketplace_seo_galicia_reviews_subtitle = /** @type {(inputs: Marketplace_Seo_Galicia_Reviews_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real reviews from boaters who booked in Rías Baixas and the Galician coast.`)
};

/**
* | output |
* | --- |
* | "Real reviews from boaters who booked in Rías Baixas and the Galician coast." |
*
* @param {Marketplace_Seo_Galicia_Reviews_SubtitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_reviews_subtitle = /** @type {((inputs?: Marketplace_Seo_Galicia_Reviews_SubtitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Reviews_SubtitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_reviews_subtitle(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_reviews_subtitle(inputs)
	return es_marketplace_seo_galicia_reviews_subtitle(inputs)
});